/**
 * A reusable Card component for displaying content in a styled container.
 */
export default function Card({
    title,
    id,
    icon,
    description,
    children,
    footer,
    compact
}: {
    title: string
    id?: string
    icon?: React.ReactNode
    description?: React.ReactNode
    children: React.ReactNode
    footer?: React.ReactNode
    /**
     * Drops the global h3 margin, which otherwise adds 24px above and 11px below the
     * title and pushes an icon out of line with it. Off by default so existing cards
     * keep their spacing. — Claude
     */
    compact?: boolean
}) {
    return (
        <section
            id={id}
            className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex flex-col gap-4"
        >
            <header className="flex items-start justify-between gap-4">
                <div className="flex items-center gap-3">
                    {icon && <div className="text-gray-600">{icon}</div>}
                    {/* font-sans overrides the global Merriweather h1-h4 rule in index.css —
                        in-app headings are Jost. */}
                    <h3
                        className={`font-sans text-lg font-medium text-ink-900 ${compact ? 'm-0' : ''}`}
                    >
                        {title}
                    </h3>
                </div>
            </header>
            {description && <p className="text-sm leading-6 text-gray-600 -mt-2">{description}</p>}
            <div className="flex-1">{children}</div>
            {footer && <div className="pt-4 border-t border-gray-100">{footer}</div>}
        </section>
    )
}
